// src/pages/DonationPage.js

import React, { useState } from 'react';
import PublicNavbar from '../components/PublicNavbar';
import Footer from '../components/Footer';
import './DonationPage.css';

const DonationPage = () => {
  // Update the filenames here to change the thermometer levels on the live site
  const [campaignStatus] = useState({
    saltLake: 'slc_thermo000.jpg',
    mesa: 'mesa_thermo010.jpg',
    dallas: 'dallas_thermo000.jpg',
    software: 'dev_thermo100.jpg'
  });

  return (
    <div className="donation-page">
      <PublicNavbar />
      
      <header className="donation-hero" style={{ backgroundImage: `url('https://firebasestorage.googleapis.com/v0/b/steps4inclusiveai.firebasestorage.app/o/site-assets%2Frefugeai%2Fgiving_banner.jpg?alt=media&token=dc7c2c8b-4a5b-497c-b52e-1ad00c4b0603')` }}>
        <div className="donation-hero-overlay">
          <div className="donation-hero-content">
            <h1>Support Our Mission</h1>
            <p>Your contribution means the world to us!</p>
          </div>
        </div>
      </header>

      <div className="donation-main-content">
        <main className="content-wrapper-gray">
          <section className="thermometer-section">
            <div className="thermometer-container">
              <img src={`/thermometers/${campaignStatus.saltLake}`} alt="Salt Lake Campaign Progress" className="thermo-img" />
              <img src={`/thermometers/${campaignStatus.mesa}`} alt="Mesa Campaign Progress" className="thermo-img" />
              <img src={`/thermometers/${campaignStatus.dallas}`} alt="Dallas Campaign Progress" className="thermo-img" />
              <img src={`/thermometers/${campaignStatus.software}`} alt="Software Development Campaign Progress" className="thermo-img" />
            </div>
          </section>

          <section className="donation-text-section">
            <h2>We are ready to launch!</h2>
            <p>
              The Refuge Ai app is now live on the Apple and Android App stores! It is available for free to all people in the 
              United States. We are so happy and exited to share this resource with everyone. We believe that it will be 
              a significant help to those in need. You are one of the first to get involved with our initial roll out! As you can 
              see, we are launching in Salt Lake City, Mesa, and Dallas. Your generous gift is deeply appreciated.
            </p>

            <div className="donate-action-container">
              <a href="https://donate.stripe.com/cNi9AT8C47D92mF9HBdnW00" target="_blank" rel="noopener noreferrer" className="donate-button">
                Donate Now
              </a>
            </div>
          </section>
        </main>
      </div>

      <Footer />
    </div>
  );
};

export default DonationPage;